import { BaseComponent, StoryBlokRichText } from '@cinch-nx/data-storyblok'
import styles from './rich-text-wrapper.module.css'
import { RichText } from '@cinch-nx/landing-ui-shared'

export interface RichTextWrapperProps extends BaseComponent {
  text: StoryBlokRichText
}

export const RichTextWrapper = (props: RichTextWrapperProps) => (
  <div className={styles.container} aria-describedby="hero-heading">
    <RichText text={props.text} />
  </div>
)
